import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable, filter } from 'rxjs';
import { AuthService } from './core/guards/auth.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isDoneLoading: Observable<boolean>;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    private authService: AuthService,
    private router: Router,
    private swUpdate: SwUpdate
  ) {
    this.isDoneLoading = this.authService.isDoneLoading$;
    this.login();

    this.matIconRegistry.addSvgIcon(
      'altarea',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/icons/altarea.svg'
      )
    );
  }

  ngOnInit(): void {
    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        window.location.reload();
      }
    });

    this.setPageConfigs();
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  get error() {
    return _.isNil(this.authService.getIdToken());
  }

  setPageConfigs() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo(0, 0);
      });
  }
}
